export const dlSearchEvent = (search) => {
    window.dataLayer.push({
        event: 'search',
        search
    });
};
